module.exports = "/img/_/_/_/assets/images/avatar/full_left/female//drow.jpg?b082506344de028bf815e8393a56e279";